import { TravelType } from '@spotnana/types/openapi/models';
import { useTranslation } from 'react-i18next';

export const useGetCo2EmissionsTooltipText = (travelType: TravelType | undefined) => {
  const { t: tt } = useTranslation('WEB');
  switch (travelType) {
    case TravelType.Hotel:
      return tt(`Estimated carbon footprint for your stay based on the hotel's sustainability practices.`);
    case TravelType.Car:
      return tt(`Estimated CO2 emissions for your rental based on car type and average mileage.`);
    case TravelType.Rail:
      return tt(`Estimated carbon footprint for your rail journey.`);
    case TravelType.Air:
      return tt(`Emitted CO2 output per traveler based on selected seating class.`);
    default:
      return '';
  }
};
